import React, { ReactElement } from "react";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Unstable_Grid2";
import useMediaQuery from "@mui/material/useMediaQuery";

import CloudboxCommands from "./CloudboxCommands";
import CloudboxDetails from "./CloudboxDetails";
import CloudboxServers from "./CloudboxServers";
import CloudboxSettings from "./CloudboxSettings";

const CloudboxManage = (): ReactElement => {
 const theme = useTheme();
 const desktopViewPort = useMediaQuery(theme.breakpoints.up("md"));

 return (
  <Stack>
   <Grid container spacing={2}>
    <Grid xs={12}>
     <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
      <CloudboxDetails />
     </Paper>
    </Grid>
    <Grid xs={desktopViewPort ? 5 : 12}>
     <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
      <CloudboxSettings />
     </Paper>
    </Grid>
    <Grid xs={desktopViewPort ? 7 : 12}>
     <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
      <CloudboxCommands />
     </Paper>
    </Grid>
    <Grid xs={12}>
     <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
      <CloudboxServers />
     </Paper>
    </Grid>
   </Grid>
  </Stack>
 );
};

export default CloudboxManage;
